module.exports = __webpack_public_path__ + "img/template-icon.4496745a.svg";